var _path, _path2, _path3, _polygon, _polygon2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon3, _circle, _polygon4, _circle2, _path29, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path30, _path31, _path32, _path33, _path34, _path35, _polygon5, _rect7, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _rect8, _polygon26, _polygon27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg403(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.19,363.42s3.86,119.85,103.92,199.75,238.71,85.61,351,93.21,198.46-56,211.4-152S692.69,380.13,646.15,270.79,603.82,125.5,505.36,58.26s-252.5-26-333.25,89.22S99.19,363.42,99.19,363.42Z",
    fill: "#00c099"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.19,363.42s3.86,119.85,103.92,199.75,238.71,85.61,351,93.21,198.46-56,211.4-152S692.69,380.13,646.15,270.79,603.82,125.5,505.36,58.26s-252.5-26-333.25,89.22S99.19,363.42,99.19,363.42Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.89,208.65s-74.55,86.5-74.55,92.46,9.21,52,23.84,56.35,22.76-3.24,25.47-18.41-6.51-36.85-6.51-36.85l32.24-29.53Z",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.22,302.2c-8.48.52-18.78-3-22.22-11.39,5.71,6.59,14.11,9.09,22.22,11.39Z",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "298.42 621.67 298.64 626.04 306.46 627.99 315.25 630.92 313.3 619.19 298.42 621.67",
    fill: "#f9b499"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "225.08 620.22 225.32 608.44 243.41 608.93 243.9 623.1 225.08 620.22",
    fill: "#f9b499"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24,362.6s.49,75.76,5.38,121.7c0,0-2.93,98.73,7.82,130h33.23s-3.91-85-1.95-102.64c0,0,2.93-65.49,10.75-90.91,0,0,20.53,88,23.46,133.92l5.86,68.42L325,617.24s-5.87-121.21-8.8-156.4c0,0-7.4-82.95-9.28-102.15l-22-4.4-58.65,4.89Z",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.69,385.57c3.1-2.23,4.95-5.39,7.23-8.38,1.17-1.6,1.22-1.59.87.4a12,12,0,0,1-2.16,4.66c-1.39,1.79-3.55,3.49-5.94,3.32Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.38,397.3a55.26,55.26,0,0,1-3.91,23.46,98.14,98.14,0,0,1,3.91-23.46Z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.82,367.21a57.44,57.44,0,0,1-2.44,25.21,133.2,133.2,0,0,1,2.44-25.21Z",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M274.69,371.12c2.57,4.5.5,11.14-4.61,12.72a10.17,10.17,0,0,1-2.09.41c.54-.49,1.13-.82,1.63-1.25,3.79-2.77,4.93-7.35,5.07-11.88Z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.31,209.14l30.79-5.38,2-5.87c1-4.88,3.28-3.91,3.28-3.91l30,2,6.84,7.82,46.92,8.8,26.39,38.12c-11.73,22.48-37.14,18.57-37.14,18.57l-11.73-25.41-28.35,26.39-73.31-15.64",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M235.1,203.76q7.59,7.06,15,14.36l-.66.06c2-2.83,3.9-5.64,6.1-8.32.3-.29.55-.71,1-.79a.55.55,0,0,1,.56.46.28.28,0,0,0,0,.13,55.23,55.23,0,0,0,4.73,7.53l-.63-.07q7.86-6.8,15.92-13.36-7.74,7.29-15.71,14.32c-1.6-2.23-3.19-4.45-4.6-6.82a5,5,0,0,1-.7-1.63.45.45,0,0,0,.46.41.8.8,0,0,0,.15,0,107.31,107.31,0,0,0-6.91,9.07q-7.47-7.54-14.72-15.32Z",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2,347.94l-17.11-130.5s-.8-6.42,4.87-9.08a9.76,9.76,0,0,1,3.15-.81l35-4.77,26.39,55.72,15.64-54.74s23.33,1,32.73,1.93a6.28,6.28,0,0,1,5.64,5.94L305,346",
    fill: "#00c099"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M261.49,258.5q2,51.78,0,103.61-2-51.78,0-103.61Z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M354.35,646.56s-18.57,2-30.3-1.95c0,0-24.44-7.82-31.28-6.84,0,0,0-16.62,6.84-13.69,0,0,6.85,4.89,12.71-2,0,0,6.84-8.8,13.69,1,0,0,5.86,12.71,17.59,15.64S354.35,646.56,354.35,646.56Z",
    fill: "#00c099"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.38,651.45H337.74c-21.51,0-24.44-2.93-24.44-2.93-6.84-4.89-6.84,1-6.84,1l-14.67-1a101.49,101.49,0,0,1,1-10.75c6.84-1,31.28,6.84,31.28,6.84,11.73,3.91,30.3,1.95,30.3,1.95C355.33,650.47,353.38,651.45,353.38,651.45Z",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250.51,637.68a3.75,3.75,0,0,1-3.23,3.41,83.64,83.64,0,0,1-26.09-.78,3.7,3.7,0,0,1-2.93-3,3.6,3.6,0,0,1,.16-1.8,24.49,24.49,0,0,1,5-7.49s0-15.64,12.71-12.71c0,0,11.73,1,10.75,16.62a9.71,9.71,0,0,1,3.53,4.5A3.77,3.77,0,0,1,250.51,637.68Z",
    fill: "#00c099"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M246.83,631.9c-5.48-.53-11.1-.88-16.62-1a30.24,30.24,0,0,1,16.62,1Z",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.5,643.72a5.29,5.29,0,0,1-4.31,4.79c-8.77,1.56-22.5-.62-27.65-1.56a3.25,3.25,0,0,1-2.69-2.93,15.58,15.58,0,0,1,1.41-6.74,3.7,3.7,0,0,0,2.93,3,83.64,83.64,0,0,0,26.09.78,3.75,3.75,0,0,0,3.23-3.41A11.52,11.52,0,0,1,251.5,643.72Z",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M270.29,185.19v10.75l-13.68,13.68L240.34,194v-9.7h.33c3.77,5.41,8.86,10.69,14.47,10.69C261.09,195,266.48,191.21,270.29,185.19Z",
    fill: "#f9b499"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M270.29,185.19c-2.93,14.66-14.66,14.66-14.66,14.66-10.75-1-15.29-14.59-15.29-14.59h.33c3.77,5.41,8.86,9.71,14.47,9.71C261.09,195,266.48,191.21,270.29,185.19Z",
    fill: "#f7a48b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M276.15,163.19c0,8.55-2.22,16.29-5.86,22-3.81,6-9.2,9.77-15.15,9.77-5.61,0-10.7-3.32-14.47-8.74-4-5.78-6.55-14-6.55-23,0-17.54,9.42-31.76,21-31.76S276.15,145.65,276.15,163.19Z",
    fill: "#f9b499"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M277.3,151s11.91-2.9,14.16-14.82-19.22-26.4-34.1-29-36.7,12.88-40.24,23.51,10.29,21.24,25.1,23.5S277.3,151,277.3,151Z",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M233.87,153s-6.44-10-8.05-1.3,5.15,12.55,8.05,12.23S233.87,153,233.87,153Z",
    fill: "#f9b499"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M274.75,153s6.45-10,8.05-1.3-5.06,12.55-8.05,12.23S274.75,153,274.75,153Z",
    fill: "#f9b499"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M231.85,152.35s.23,6.48,2.39,4.79,2.87-12.68,1-14.12S231.85,149,231.85,152.35Z",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M272.43,151.38s.25,6.47,2.39,4.79,2.89-12.69,1-14.12S272.43,148,272.43,151.38Z",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M230.87,146.11s.72.59.71.88c3.12,1.69,10.29,4.79,21.93,5.41a44.75,44.75,0,0,0,23.62-5.78v-1.39c-.28-7.54-5.89-12.57-12.82-14.49a33,33,0,0,0-20.65,1,20.26,20.26,0,0,0-8.56,6.16C234.24,138.87,229.69,145.17,230.87,146.11Z",
    fill: "#00c099"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M231.61,146.53a76.59,76.59,0,0,0,21.93,1.61c13.86-.65,23.49-1.61,23.49-1.61a38.18,38.18,0,0,1-23.28,10.23A25.54,25.54,0,0,1,231.61,146.53Z",
    fill: "#00c099"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M231.61,146.53a76.59,76.59,0,0,0,21.93,1.61c13.86-.65,23.49-1.61,23.49-1.61a38.18,38.18,0,0,1-23.28,10.23A25.54,25.54,0,0,1,231.61,146.53Z",
    opacity: 0.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "204.85 235.53 207.1 251.66 224.53 255.84 242.26 248.75 240.98 234.23 204.85 235.53",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 223.4,
    cy: 248.59,
    r: 3.07,
    opacity: 0.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.35 238.46 272.59 254.59 290.02 258.77 307.75 251.69 306.47 237.16 270.35 238.46",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.89,
    cy: 251.52,
    r: 3.07,
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M173,336.88s16.8-2.72,21.14-1.64,7.58,11.39,7.58,11.39,1.63,15.18-1.1,18.42-15.71,7-21.11,8.13-16.82-11.37-21.24-19S161.63,333.62,173,336.88Z",
    fill: "#f9b499"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 201.74,
    y: 340.67,
    width: 117.04,
    height: 18.42,
    fill: "#2e3135"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.62,
    y: 341.75,
    width: 35.77,
    height: 22.76,
    rx: 5.15,
    fill: "#3f4347"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 286.82,
    y: 341.75,
    width: 35.77,
    height: 22.76,
    rx: 5.15,
    fill: "#3f4347"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 249.43,
    y: 341.75,
    width: 25.46,
    height: 16.25,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 204.8,
    y: 203.76,
    width: 24.44,
    height: 3.91,
    transform: "translate(-26.6 32.32) rotate(-8.03)",
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 280.06,
    y: 201.8,
    width: 24.44,
    height: 3.91,
    transform: "translate(8.03 -11.06) rotate(2.2)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M309.33,241.31a4.58,4.58,0,0,1,2.43,3.29c1.56,9.47,7.89,41.24,22.07,35.4,0,0,14.66-5.86,10.75-15.64L328.94,238s2.93-1,2.93-11.73v-30.3s-1-8.8-5.86-5.87c0,0-1-13.68-6.85-10.75,0,0,0-5.86-3.91-5.86,0,0-1.95,0-1.95,4.88,0,0-5.87-2.93-5.87,6.85l-1,17.59s-3.91-2.93-6.85-1.95l.82,24.5a19.6,19.6,0,0,0,3.36,10.43A17.57,17.57,0,0,0,309.33,241.31Z",
    fill: "#f9b499"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M306.46,202.78a102.41,102.41,0,0,1,1.93,13.62l-.72-.86a12.49,12.49,0,0,1,4.15,2.15,16.18,16.18,0,0,1,5.32,7.2,19.13,19.13,0,0,1,1.05,4.28l-.95-1.95c-2.21-4.43-5.86-8.65-10.72-10.05a103.15,103.15,0,0,1-.06-14.39Z",
    fill: "#f7a48b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313.3,178.34a74.85,74.85,0,0,1-1,24.44,74.86,74.86,0,0,1,1-24.44Z",
    fill: "#f7a48b"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M319.16,179.32a68.2,68.2,0,0,1,0,23.46,68.7,68.7,0,0,1,0-23.46Z",
    fill: "#f7a48b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M326,190.07a27.37,27.37,0,0,1,0,14.67,27.17,27.17,0,0,1,0-14.67Z",
    fill: "#f7a48b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M555.64,638.85H535.88V43.47c0-3.21,19.76-3.21,19.76,0Z",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "555.64 267.06 535.88 271.03 535.88 243.7 555.64 243.7 555.64 267.06"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 447.82,
    y: -8.07,
    width: 197.25,
    height: 319.14,
    rx: 20.56,
    transform: "translate(354.87 685.21) rotate(-85.75)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M679.29,262.82h-1.72L400.32,242.26A23.2,23.2,0,0,1,379,217.48L390.55,61.79a23.2,23.2,0,0,1,24.78-21.37L692.58,61a23.21,23.21,0,0,1,21.36,24.78L702.35,241.45a23.18,23.18,0,0,1-23.05,21.42ZM413.58,45.39a18,18,0,0,0-17.92,16.72l-11.59,155.7A18,18,0,0,0,400.61,237l277.25,20.56A18,18,0,0,0,697.14,241L708.73,85.28A18,18,0,0,0,692.12,66L414.87,45.44C414.49,45.4,414,45.39,413.58,45.39Z",
    fill: "#00c099"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M488.76,125.6,453.94,123l1.16-15.71L493,68.47l16.67,1.23L506.53,112l8.56.65L514,127.47l-8.57-.64-1,12.87-16.66-1.25Zm1.11-14.84,1.56-21.66-20,20.29Z",
    fill: "#00c099"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M521.66,106.1q1.47-19.63,9.18-26.85T553,73a32.8,32.8,0,0,1,11.29,2.57,21.63,21.63,0,0,1,6.94,5,24.77,24.77,0,0,1,4,6.1,31.21,31.21,0,0,1,1.92,7.18,65.5,65.5,0,0,1,.73,16.19q-1.41,18.75-8.38,26.94T547,144a30.67,30.67,0,0,1-13.83-3.81,22.81,22.81,0,0,1-8.17-8.77,30.59,30.59,0,0,1-3.1-10.69A70.53,70.53,0,0,1,521.66,106.1Zm19,1.44q-1,13.15,1,18.15c1.3,3.3,3.43,5.14,6.38,5.31a7.1,7.1,0,0,0,5.14-1.72,12.6,12.6,0,0,0,3.61-6.22,67.46,67.46,0,0,0,2-13.71q1-13.69-1-18.59a7.44,7.44,0,0,0-6.61-5.24,7.12,7.12,0,0,0-7.22,4.3Q541.58,94.55,540.61,107.54Z",
    fill: "#00c099"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M605.38,98.1l-17.84-4.58a22.69,22.69,0,0,1,9.65-12.59q6.75-4.16,18.49-3.26,13.47,1,19.11,6.48a15.85,15.85,0,0,1,5.14,13.07,14.15,14.15,0,0,1-3,7.89,20.66,20.66,0,0,1-7.83,5.79,21.9,21.9,0,0,1,5.92,2.76,14.86,14.86,0,0,1,4.92,6,16.83,16.83,0,0,1,1.29,8.38,23.21,23.21,0,0,1-4.1,11.22A21.15,21.15,0,0,1,627.4,147a34.9,34.9,0,0,1-15.76,1.83A40.92,40.92,0,0,1,597,145.56a22.19,22.19,0,0,1-8.43-7.13A29.9,29.9,0,0,1,584,127.36l19.3-1.11a14.87,14.87,0,0,0,2.91,8.26,9,9,0,0,0,12.47.34,10.69,10.69,0,0,0,3.12-7.33,10.24,10.24,0,0,0-1.92-7.59,8.68,8.68,0,0,0-6.49-3.12,24,24,0,0,0-6.27.65l2-13.59a18.76,18.76,0,0,0,2.47.43,8.73,8.73,0,0,0,6.44-1.94,7.46,7.46,0,0,0,2.93-5.48,6.83,6.83,0,0,0-1.49-5.14,7,7,0,0,0-5-2.21,7.64,7.64,0,0,0-5.64,1.71A12.42,12.42,0,0,0,605.38,98.1Z",
    fill: "#00c099"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M462.42,152.61l26.59,2-.51,6.86-16.64-1.23-.39,5.14,15.42,1.16-.5,6.55L471,172l-.46,6.32,17.13,1.29-.53,7.26-27.07-2Z",
    fill: "#00c099"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M492.58,187.2l2.4-32.11,16.53,1.22a24.09,24.09,0,0,1,7,1.32,7.5,7.5,0,0,1,3.7,3.22,9.94,9.94,0,0,1-.38,9.83,9.05,9.05,0,0,1-3.43,2.92,12,12,0,0,1-3.58,1,6.67,6.67,0,0,1,4,3.18,13.07,13.07,0,0,1,1.25,2.1l4.11,9.66-11.22-.84-4.58-10.28a7.36,7.36,0,0,0-1.61-2.61,4.17,4.17,0,0,0-2.36-.92h-.87l-1,13ZM504,168.83l4.18.31a13.23,13.23,0,0,0,2.66-.24,2.68,2.68,0,0,0,1.71-.87,3.12,3.12,0,0,0,.76-1.84,2.93,2.93,0,0,0-.81-2.45,6,6,0,0,0-3.63-1.11l-4.37-.33Z",
    fill: "#00c099"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M527.41,189.74l2.39-32.11,16.55,1.23a24.33,24.33,0,0,1,7,1.3,7.58,7.58,0,0,1,3.71,3.22,9.11,9.11,0,0,1-3.25,12.48,4.82,4.82,0,0,1-.5.27,11.73,11.73,0,0,1-3.58,1,10.3,10.3,0,0,1,2.5,1.37,12.13,12.13,0,0,1,1.46,1.82,11.24,11.24,0,0,1,1.23,2.09l4.11,9.67-11.2-.83L543.21,181a7.47,7.47,0,0,0-1.61-2.6,4.08,4.08,0,0,0-2.38-.93h-.87l-1,13Zm11.4-18.35,4.18.3a14.87,14.87,0,0,0,2.66-.24,2.57,2.57,0,0,0,1.71-.89,2.93,2.93,0,0,0,.77-1.81,3,3,0,0,0-.8-2.47,6,6,0,0,0-3.65-1.1l-4.27-.25Z",
    fill: "#00c099"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M561.43,176.15a15.25,15.25,0,0,1,14.85-15.64,15.52,15.52,0,0,1,3,.22q8,.59,12,5.22a16.33,16.33,0,0,1,3.43,12.39,19.64,19.64,0,0,1-2.59,9.09,13.54,13.54,0,0,1-5.89,5.14,18.16,18.16,0,0,1-9.08,1.49,20.59,20.59,0,0,1-8.88-2.4,13.56,13.56,0,0,1-5.36-5.91A18.18,18.18,0,0,1,561.43,176.15Zm9.92.77a10.88,10.88,0,0,0,1.28,7.13,6.86,6.86,0,0,0,9.65,1l.22-.19q1.9-1.95,2.3-7.33a10,10,0,0,0-1.34-6.86,6.29,6.29,0,0,0-4.79-2.45,6,6,0,0,0-5,1.72A10.76,10.76,0,0,0,571.35,176.92Z",
    fill: "#00c099"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M599,195.07l2.38-32.13,16.54,1.23a24.42,24.42,0,0,1,7,1.32,7.38,7.38,0,0,1,3.63,3.21,8.86,8.86,0,0,1,1.12,5.31,9.07,9.07,0,0,1-1.49,4.54,8.89,8.89,0,0,1-3.43,2.89,11.77,11.77,0,0,1-3.58,1,6.9,6.9,0,0,1,4,3.17,12.36,12.36,0,0,1,1.23,2.11l4.11,9.67-11.2-.84-4.58-10.29a7.71,7.71,0,0,0-1.61-2.6,4.24,4.24,0,0,0-2.38-.93h-.88l-1,13Zm11.38-18.37,4.18.31a14.9,14.9,0,0,0,2.67-.24,2.66,2.66,0,0,0,1.72-.89,2.93,2.93,0,0,0,.77-1.82,3,3,0,0,0-.81-2.45,5.88,5.88,0,0,0-3.65-1.11l-4.35-.33Z",
    fill: "#00c099"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M429.31,220.34l2.18-29.3,19.77,1.47-.25,3.43-15.91-1.18-.66,9.06,13.7,1-.25,3.43-13.71-1-1,13.32Z",
    fill: "#2f2e41"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M454,207.77a16,16,0,0,1,4.77-11.14,13.33,13.33,0,0,1,10.42-3.43,14.24,14.24,0,0,1,7.18,2.48,12.74,12.74,0,0,1,4.55,5.78,17.74,17.74,0,0,1,1.14,8,17.44,17.44,0,0,1-2.4,7.83,12.22,12.22,0,0,1-5.5,5,14.5,14.5,0,0,1-7.25,1.29,13.92,13.92,0,0,1-7.25-2.55,12.8,12.8,0,0,1-4.52-5.83A16.62,16.62,0,0,1,454,207.77Zm4,.36a11.8,11.8,0,0,0,2.22,8.56,10,10,0,0,0,14,1.33l.33-.28a12.49,12.49,0,0,0,3.42-8.57,15,15,0,0,0-.73-6.34,9.42,9.42,0,0,0-3.22-4.39,9.68,9.68,0,0,0-5.14-1.86,9.88,9.88,0,0,0-7.3,2.31c-2.06,1.82-3.28,4.9-3.6,9.3Z",
    fill: "#2f2e41"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M486,224.56l2.2-29.3,13,1a17.05,17.05,0,0,1,5.89,1.24,6.5,6.5,0,0,1,3.05,3A8.36,8.36,0,0,1,511,205a7.45,7.45,0,0,1-2.41,5.14,10.36,10.36,0,0,1-6.43,2.24,10.47,10.47,0,0,1,2.23,1.63,21.59,21.59,0,0,1,2.93,4.15l4.5,8.36-4.88-.38-3.43-6.37c-1-1.85-1.83-3.26-2.5-4.25a8.51,8.51,0,0,0-1.81-2.11,6.17,6.17,0,0,0-1.72-.91,14,14,0,0,0-2.14-.31l-4.51-.32-1,13Zm5.14-16.08,8.33.62a12.34,12.34,0,0,0,4.2-.24,4.46,4.46,0,0,0,2.42-1.59,4.72,4.72,0,0,0,1-2.57,4.4,4.4,0,0,0-1.25-3.53,7.1,7.1,0,0,0-4.68-1.72l-9.27-.7Z",
    fill: "#2f2e41"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M515.42,226.75l2.17-29.3,11,.8a13.62,13.62,0,0,1,5.31,1.31,7,7,0,0,1,3,3,7.37,7.37,0,0,1,.86,4,6.51,6.51,0,0,1-1.29,3.43,7.3,7.3,0,0,1-3.27,2.45,7.74,7.74,0,0,1,3.89,3,7.19,7.19,0,0,1,1.09,4.54,8.63,8.63,0,0,1-1.14,3.77,7.58,7.58,0,0,1-2.37,2.57,8.85,8.85,0,0,1-3.31,1.2,19,19,0,0,1-4.76.14Zm4.13-3.17,7.3.55a19.53,19.53,0,0,0,2.65,0,6.79,6.79,0,0,0,2.3-.63,4.4,4.4,0,0,0,1.59-1.53,5.32,5.32,0,0,0,.14-5.33,4.38,4.38,0,0,0-2.21-1.88,14.67,14.67,0,0,0-4.25-.81l-6.77-.5Zm1-13.54,6.34.48a14.47,14.47,0,0,0,3.72,0,4,4,0,0,0,2.33-1.3,4.17,4.17,0,0,0,.94-2.5,4.76,4.76,0,0,0-.5-2.62,3.67,3.67,0,0,0-1.9-1.72,16.55,16.55,0,0,0-4.42-.73l-5.86-.45Z",
    fill: "#2f2e41"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M543.49,228.84l2.17-29.3,3.89.29-2.19,29.3Z",
    fill: "#2f2e41"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M554.2,229.63l2.19-29.3,10.09.75a24.8,24.8,0,0,1,5.14.81,9.88,9.88,0,0,1,4.15,2.41,12.06,12.06,0,0,1,3.1,5.28,19.24,19.24,0,0,1,.62,7,19.88,19.88,0,0,1-1.22,5.86A13.82,13.82,0,0,1,576,226.6a10.52,10.52,0,0,1-2.86,2.46,10.84,10.84,0,0,1-3.62,1.22,20.32,20.32,0,0,1-4.74.14Zm4.14-3.15,6.26.46a15.37,15.37,0,0,0,4.59-.21,6.59,6.59,0,0,0,2.74-1.32,9.37,9.37,0,0,0,2.42-3.56,18.15,18.15,0,0,0,1.2-5.59,13.72,13.72,0,0,0-1-7.18,7.66,7.66,0,0,0-3.42-3.58,15.66,15.66,0,0,0-5-1l-6.15-.46Z",
    fill: "#2f2e41"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M583.77,231.84l2.18-29.3,10.09.74a23.55,23.55,0,0,1,5.14.82,9.75,9.75,0,0,1,4.13,2.41,11.81,11.81,0,0,1,3.1,5.26,19.75,19.75,0,0,1,.64,7,21.4,21.4,0,0,1-1.22,5.86,14.06,14.06,0,0,1-2.33,4.13,10.66,10.66,0,0,1-2.86,2.45,10.94,10.94,0,0,1-3.6,1.21,21,21,0,0,1-4.75.16Zm4.13-3.17,6.26.46a15.7,15.7,0,0,0,4.59-.2,6.59,6.59,0,0,0,2.74-1.32,9.33,9.33,0,0,0,2.42-3.55,18.44,18.44,0,0,0,1.2-5.59,13.67,13.67,0,0,0-1-7.17,7.54,7.54,0,0,0-3.42-3.59,15.25,15.25,0,0,0-5-1l-6.15-.47Z",
    fill: "#2f2e41"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M613.42,234l2.17-29.3,21.18,1.58-.25,3.43-17.31-1.29-.67,9,16.21,1.2-.26,3.43-16.21-1.22-.73,10,18,1.36-.26,3.42Z",
    fill: "#2f2e41"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M640.59,236.06l2.18-29.31,4,.3,13.71,24.16,1.71-23,3.72.28-2.2,29.32-4-.31L646,213.32l-1.71,23Z",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.69 655.79 365.82 655.79 398.43 396.74 443.31 396.74 410.69 655.79",
    fill: "#00c099"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "410.69 655.79 365.82 655.79 398.43 396.74 443.31 396.74 410.69 655.79",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.81 655.79 365.82 655.79 398.43 396.74 394.42 396.74 361.81 655.79",
    fill: "#2e3135"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "578.01 655.79 533.15 655.79 565.76 396.74 610.64 396.74 578.01 655.79",
    fill: "#00c099"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "578.01 655.79 533.15 655.79 565.76 396.74 610.64 396.74 578.01 655.79",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "529.13 655.79 533.15 655.79 565.76 396.74 561.75 396.74 529.13 655.79",
    fill: "#2e3135"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "452.22 624.97 614.94 624.97 607.85 568.57 445.13 568.57 452.22 624.97",
    fill: "#00c099"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "452.22 624.97 449.57 624.97 442.45 568.57 445.13 568.57 452.22 624.97",
    fill: "#263238"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "605.98 571.04 612.46 622.5 602.85 622.5 577.02 571.04 605.98 571.04",
    fill: "#fff"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "560.62 571.04 586.45 622.5 551.15 622.5 525.32 571.04 560.62 571.04",
    fill: "#fff"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.92 571.04 534.75 622.5 499.43 622.5 473.63 571.04 508.92 571.04",
    fill: "#fff"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "457.24 571.04 483.05 622.5 454.09 622.5 447.61 571.04 457.24 571.04",
    fill: "#fff"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.37 655.79 644.25 655.79 611.62 396.74 566.76 396.74 599.37 655.79",
    fill: "#00c099"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "581.29 512.15 628.5 530.7 614.94 423.13 570.06 423.13 581.29 512.15",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.37 655.79 595.36 655.79 562.75 396.74 566.76 396.74 599.37 655.79",
    fill: "#2e3135"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.04 655.79 476.92 655.79 444.31 396.74 399.43 396.74 432.04 655.79",
    fill: "#00c099"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "413.96 512.15 461.17 530.7 447.61 423.13 402.75 423.13 413.96 512.15",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.04 655.79 428.03 655.79 395.42 396.74 399.43 396.74 432.04 655.79",
    fill: "#2e3135"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "396.03 500.2 641.06 500.2 630.37 415.3 385.34 415.3 396.03 500.2",
    fill: "#00c099"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "396.03 500.2 392.02 500.2 381.33 415.3 385.34 415.3 396.03 500.2",
    fill: "#263238"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "627.55 419 637.32 496.48 622.84 496.48 583.96 419 627.55 419",
    fill: "#fff"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "559.27 419 598.15 496.48 544.98 496.48 506.11 419 559.27 419",
    fill: "#fff"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "481.42 419 520.3 496.48 467.13 496.48 428.25 419 481.42 419",
    fill: "#fff"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.59 419 442.45 496.48 398.84 496.48 389.09 419 403.59 419",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 634.59,
    y: 645.65,
    width: 122.35,
    height: 9.18,
    fill: "#2f2e41"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "736.29 645.39 655.24 645.39 687.01 472.57 704.52 472.57 736.29 645.39",
    fill: "#00c099"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "675.21 536.81 716.34 536.81 712.39 515.4 679.14 515.4 675.21 536.81",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M724.11,616.54a17.13,17.13,0,0,1,2,11.82,17.18,17.18,0,0,1-2-11.82Z",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701,482.12q12.4,59.4,20.59,119.56Q709.13,542.3,701,482.12Z",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.0278129b5411d2a2df610d57c9262866.svg";
export { ForwardRef as ReactComponent };